import React from 'react'
import { FormikProps, withFormik, Form } from 'formik'
import Input from '../../components/input'
import { Trans, useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

interface PasswordProps {
  onSubmit: (values: PasswordValues) => void
  children?: React.ReactNode
  user: string
  password: string
  newPassword: string
  confirmNewPassword: string
}

interface PasswordValues {
  user: string
  password: string
  newPassword: string
  confirmNewPassword: string
}

const InnerForm: React.FunctionComponent<
  PasswordProps & FormikProps<PasswordValues>
> = ({ values, errors, handleChange, handleBlur, touched, children }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className="container-titles">
        <span className="sub-title color-grey-dark">{`${t(
          'SECURITY_AND_AUTHENTICATION'
        )}`}</span>
        <span className="sub-title">{`${t('CHANGE_PASSWORD')}`}</span>
        <p>{`${t('LOGIN_AFTER_CHANGE_PASSWORD')}`}</p>
      </div>
      <Form>
        <Input
          id="password"
          label={`${t('CURRENT_PASSWORD')}`}
          type="password"
          value={values.password}
          onChange={handleChange}
          touched={touched.password}
          classNameInput="input"
          required={true}
          className="col-12 col-md-6"
        />
        <Input
          id="newPassword"
          label={`${t('NEW_PASSWORD')}`}
          type="password"
          value={values.newPassword}
          onChange={handleChange}
          touched={touched.newPassword}
          classNameInput="input"
          required={true}
          className="col-12 col-md-6"
        />

        <Input
          id="confirmNewPassword"
          label={`${t('CONFIRM_NEW_PASSWORD')}`}
          type="password"
          value={values.confirmNewPassword}
          onChange={handleChange}
          touched={touched.confirmNewPassword}
          classNameInput="input"
          required={true}
          className="col-12 col-md-6"
        />

        <div className="container-buttton">
          <button className="button-second width-auto" type="submit">
            {`${t('UPDATE_PASSWORD')}`}
          </button>
        </div>
      </Form>
    </>
  )
}

const PasswordForm = withFormik<PasswordProps, PasswordValues>({
  mapPropsToValues: (props) => {
    const initialValues: PasswordValues = {
      user: props.user,
      password: props.password,
      newPassword: props.newPassword,
      confirmNewPassword: props.confirmNewPassword,
    }
    return { ...initialValues, ...props }
  },

  handleSubmit(values: PasswordValues, { props }) {
    if (
      values.password !== '' ||
      values.newPassword !== '' ||
      values.confirmNewPassword !== ''
    ) {
      if (values.newPassword === values.confirmNewPassword) {
        props.onSubmit(values)
      } else {
        toast(<Trans>{'PASSWORD_DO_NOT_MATCH'}</Trans>)
      }
    } else {
      toast(<Trans>{'FILL_VALUES'}</Trans>)
    }
  },
})(InnerForm)
export default PasswordForm
